var exports = {
  "zr": "ScreenSharePickerModal.module__root___Tkh3a3",
  "XV": "ScreenSharePickerModal.module__topBar___Tkh3a3",
  "vR": "ScreenSharePickerModal.module__tabs___Tkh3a3",
  "Gn": "ScreenSharePickerModal.module__tabLabel___Tkh3a3",
  "Ll": "ScreenSharePickerModal.module__tabIcon___Tkh3a3",
  "Qs": "ScreenSharePickerModal.module__content___Tkh3a3",
  "Vg": "ScreenSharePickerModal.module__grid___Tkh3a3",
  "Nr": "ScreenSharePickerModal.module__card___Tkh3a3",
  "e5": "ScreenSharePickerModal.module__cardPending___Tkh3a3",
  "VH": "ScreenSharePickerModal.module__preview___Tkh3a3",
  "np": "ScreenSharePickerModal.module__previewDevice___Tkh3a3",
  "Gh": "ScreenSharePickerModal.module__cardSelected___Tkh3a3",
  "oz": "ScreenSharePickerModal.module__previewImage___Tkh3a3",
  "yQ": "ScreenSharePickerModal.module__devicePreviewVideo___Tkh3a3",
  "A3": "ScreenSharePickerModal.module__previewPlaceholder___Tkh3a3",
  "Cd": "ScreenSharePickerModal.module__devicePreviewPlaceholder___Tkh3a3",
  "mP": "ScreenSharePickerModal.module__previewIcon___Tkh3a3",
  "rP": "ScreenSharePickerModal.module__previewOverlay___Tkh3a3",
  "H5": "ScreenSharePickerModal.module__previewAction___Tkh3a3",
  "zI": "ScreenSharePickerModal.module__cardBody___Tkh3a3",
  "Dm": "ScreenSharePickerModal.module__cardSourceIcon___Tkh3a3",
  "gL": "ScreenSharePickerModal.module__cardSourceIconImage___Tkh3a3",
  "JJ": "ScreenSharePickerModal.module__cardTitle___Tkh3a3",
  "wk": "ScreenSharePickerModal.module__state___Tkh3a3",
  "Ml": "ScreenSharePickerModal.module__loadingState___Tkh3a3",
  "hZ": "ScreenSharePickerModal.module__stateIcon___Tkh3a3",
  "CY": "ScreenSharePickerModal.module__stateHeading___Tkh3a3",
  "_A": "ScreenSharePickerModal.module__stateTitle___Tkh3a3",
  "tM": "ScreenSharePickerModal.module__stateActions___Tkh3a3",
  "xj": "ScreenSharePickerModal.module__osNotice___Tkh3a3",
  "Hr": "ScreenSharePickerModal.module__downloadCta___Tkh3a3",
  "wN": "ScreenSharePickerModal.module__downloadCopy___Tkh3a3",
  "z5": "ScreenSharePickerModal.module__downloadTitle___Tkh3a3",
  "h": "ScreenSharePickerModal.module__downloadDescription___Tkh3a3",
  "qm": "ScreenSharePickerModal.module__downloadActions___Tkh3a3",
  "aQ": "ScreenSharePickerModal.module__platformIcons___Tkh3a3",
  "tV": "ScreenSharePickerModal.module__platformIcon___Tkh3a3",
  "qr": "ScreenSharePickerModal.module__footer___Tkh3a3",
  "wu": "ScreenSharePickerModal.module__footerStart___Tkh3a3",
  "vM": "ScreenSharePickerModal.module__streamSummary___Tkh3a3",
  "ru": "ScreenSharePickerModal.module__streamSummaryTitle___Tkh3a3",
  "$o": "ScreenSharePickerModal.module__streamSummaryDetails___Tkh3a3",
  "sw": "ScreenSharePickerModal.module__streamSummaryDetail___Tkh3a3",
  "Xd": "ScreenSharePickerModal.module__streamButton___Tkh3a3",
  "ZF": "ScreenSharePickerModal.module__previewNotice___Tkh3a3",
  "cP": "ScreenSharePickerModal.module__previewNoticeText___Tkh3a3",
  "vw": "ScreenSharePickerModal.module__previewNoticeInfoButton___Tkh3a3",
  "Ip": "ScreenSharePickerModal.module__previewInfoContent___Tkh3a3",
  "Jh": "ScreenSharePickerModal.module__previewInfoParagraph___Tkh3a3",
  "NZ": "ScreenSharePickerModal.module__previewInfoSwitch___Tkh3a3",
};

module.exports = exports;
